<div>
  <p-dialog appendTo="body" [(visible)]="visible" (onHide)="hide()" [modal]="true"
    [style]="{'width': '700px', 'height': '750px'}" [resizable]="false">

    <p-header>
      <span>PRTG Monitor</span>
    </p-header>

    <div>
      <p-tabView>
        <p-tabPanel header="Settings" headerStyleClass="data-tab" [selected]="true">
          <prtg-settings-2 [editor]="policyEditor" [visible]="visible"></prtg-settings-2>
        </p-tabPanel>
        <p-tabPanel header="Schedule" headerStyleClass="data-tab">
          <monitor-schedule [editor]="policyEditor" [visible]="visible"></monitor-schedule>
        </p-tabPanel>
      </p-tabView>
    </div>

    <p-footer>
      <button type="button" pButton icon="fa fa-check" [disabled]="!isSaveEnabled()" (click)="onSaveClicked()"
        label="Save"></button>
      <button type="button" pButton icon="fa fa-close" (click)="onCancelClicked()" label="Cancel"></button>
    </p-footer>
  </p-dialog>

  <p-dialog [(visible)]="showInvalidTempChangesDialog" appendTo="body">
    <p-header>
      <span>Invalid Changes</span>
    </p-header>
    <p>
      Invalid changes have been made in the following tabs and cannot be saved.
    </p>
    <ul>
      @for (tabName of tabsWithErrors; track tabName) {
      <li>{{tabName}}</li>
      }
    </ul>
    <p-footer>
      <button type="button" pButton (click)="onCancelSave()" label="Close"></button>
    </p-footer>
  </p-dialog>

</div>